import * as FileDownloadService from '../../utils/macros/file';

type SetStateFn = React.Component<any, TicketState>["setState"];

const macroStrategiesRegistration: Record<
  number,
  (state: TicketState, action: MacroAction,
    props: {
      changeValues: (stateName: string, value: any, text: string) => Promise<void>,
      setState: SetStateFn,
      organizationsList?: Array<any>,
      getUsersById: (id: number) => Promise<any>,
      getTechinicalteamIdById: (id: number) => Promise<any>,
      getOrganizationCategoryById?: (id: any) => Promise<void>,
      getAddressById?: (id: any) => Promise<void>,
      getOrganizationFieldById?: (id: any) => Promise<any>,
      getActiveOrganizationFieldsByOrganizationAndCategories?: (id: any) => Promise<any>,
      setTitle?: (item: any) => void,
      setDescription?: (item: any) => void,
    }) => Promise<any>
> = {

  // Definir tipo como
  2: async (state, action, { changeValues }) => {
    await changeValues("type", action.sourceentityid || null, "");
  },

  // Definir status como
  3: async (state, action, { changeValues }) => {
    await changeValues("status", action.sourceentityid || null, "");
  },

  // Adicionar acompanhamento
  //NÃO TEM
  4: async (state, action) => { },

  // Atribuir Agente
  6: async (state, action, { changeValues, getUsersById }) => {
    const user = getUsersById ? await getUsersById(Number(action.sourceentityid) || 0) : null;

    await changeValues("assignedUser", user, "");
  },

  // Atribuir Observador (múltiplos)
  7: async (state, action, { changeValues }) => {
    let observers: any[] = [];
    try {
      observers = action.sourceentityvalue ? JSON.parse(action.sourceentityvalue) : [];
    } catch (_) {
      observers = [];
    }

    await changeValues("observantUsers", Array.isArray(observers) ? observers : [], "");
  },

  // Atribuir Time
  8: async (state, action, { changeValues, getTechinicalteamIdById }) => {
    const newTeamId = Number(action.sourceentityid) || 0;

    const techinicalteam = getTechinicalteamIdById ? await getTechinicalteamIdById(newTeamId) : null;

    await changeValues("techinicalTeam", techinicalteam, "");
  },

  // Adicionar Ação Padrão
  //NÃO TEM
  9: async (state, action) => { },

  // Adicionar tag
  13: async (state, action, { setState }) => {
    const tags = action.sourceentityvalue?.split(",")?.filter((ac) => ac) ?? [];

    setState((prevState) => ({
      tags: [...prevState.tags, ...tags]
    }))
  },

  // Definir valor campo personalizado
  14: async (state, action, { changeValues, getOrganizationFieldById, getActiveOrganizationFieldsByOrganizationAndCategories }) => {
    const ofieldId = Number(action.sourceentityid) || 0;
    const organizationField = getOrganizationFieldById ? await getOrganizationFieldById(ofieldId) : null;

    if(organizationField == null || organizationField.id == null || organizationField.organizationid == null) return;

    const fieldOrganizationId = organizationField?.organizationid || null;
    const organizationFieldType = organizationField?.organizationfieldtype;
    const fieldCategoryId = action.organizationfieldcategoryid ?? null;

    if (fieldCategoryId != null) {
      return {
        customMacroOrganizationId: fieldOrganizationId,
        pendingCategoryId: fieldCategoryId,
        pendingOField: {
          stateName: `ofield-${ofieldId}`,
          optionValue: action.sourceentityvalue,
          fieldType: organizationFieldType,
          maxlength: organizationField.maxlength ?? null
        }
      };
    }

    // Campo sem categoria: busca opções e seta diretamente
    const resultOrganizationFieldList = getActiveOrganizationFieldsByOrganizationAndCategories ? await getActiveOrganizationFieldsByOrganizationAndCategories(fieldOrganizationId) : null;
    let organizationfieldoptionsvalues = [];

    if (resultOrganizationFieldList != null && resultOrganizationFieldList.success) {
      const resultOrganizationFieldListData = resultOrganizationFieldList.data;

      const organizationFieldList = resultOrganizationFieldListData && resultOrganizationFieldListData.length > 1 ? resultOrganizationFieldListData.sort((a: any, b: any) => a.name.localeCompare(b.name)) : resultOrganizationFieldListData;

      organizationfieldoptionsvalues = organizationFieldList?.find((f: any) => f.id == ofieldId)?.organizationfieldoptionsvalues
        || organizationFieldList?.find((f: any) => f.organizationfieldtype == organizationFieldType)?.organizationfieldoptionsvalues
        || [];
    }

    const stateName = `ofield-${ofieldId}`;
    let value = null;

    const valueByType: Record<number, () => any> = {
      1: () => organizationField.maxlength ? action.sourceentityvalue || "".slice(0, organizationField.maxlength) : action.sourceentityvalue || "", //TextField
      2: () => {
        if (!action.sourceentityvalue) return null;
        const optName = organizationfieldoptionsvalues?.find((opt: any) => Number(opt.id) == Number(action.sourceentityvalue))?.name || action.sourceentityvalue;
        return optName + '\n' + action.sourceentityvalue;
      }, //RadioGroup
      3: () => (action.sourceentityvalue || null) == "true", //SimpleCheckBox
      4: () => {
        if (!action.sourceentityvalue) return null;
        return organizationfieldoptionsvalues?.find((opt: any) => Number(opt.id) == Number(action.sourceentityvalue)) ?? null;
      }, //SimpleAutoComplete
      5: () => action.sourceentityvalue || null, //Number
      6: () => action.sourceentityvalue || null, //SelectMultiple
      7: () => action.sourceentityvalue || null, //TextMultipleLine
      8: () => action.sourceentityvalue || null, //Decimal
      9: () => action.sourceentityvalue || null, //Date
      10: () => action.sourceentityvalue || null, //RegexText
    };

    if (valueByType[organizationFieldType]) {
      value = valueByType[organizationFieldType]();
    }

    await changeValues(stateName, value, "handleApplyMacro");

    return {
      customMacroOrganizationId: fieldOrganizationId
    }
  },

  // Definir categoria como
  15: async (state, action, { changeValues, getOrganizationCategoryById }) => {
    const categoryId = Number(action.sourceentityvalue) || 0;
    const category = getOrganizationCategoryById ? await getOrganizationCategoryById(categoryId) : null;

    await changeValues("CategoryId", category, "");
  },

  // Definir texto do título
  16: async (state, action, { setTitle }) => {

    setTitle(action.sourceentityvalue || "");
  },

  // Definir texto da descrição
  17: async (state, action, { setDescription }) => {

    setDescription(action.sourceentityvalue || "");
  },

  // Definir anexos do chamado
  18: async (state, action, { setState }) => {
    const fileDatas = await FileDownloadService.getDataFiles([action]);

    setState((prevState) => ({
      files: fileDatas
    }));
  },

  // Definir organização
  19: async (state, action, { changeValues, organizationsList }) => {
    const orgId = Number(action.sourceentityid) || 0;

    if (state.called.organization && state.called.organization.id && state.called.organization.id == orgId) return;

    const organization = organizationsList?.find((org) => org.id == orgId) || null;

    await changeValues("organization", organization, "handleApplyMacro");
  },

  // Define o valor da localização(endereço) do chamado.
  20: async (state, action, { changeValues, getAddressById }) => {
    const addressId = Number(action.sourceentityvalue) || 0;

    const address = getAddressById ? await getAddressById(addressId) : null;

    await changeValues("AddressId", address, "");
  },

  // Define o solicitante do chamado.
  21: async (state, action, { changeValues, getUsersById }) => {
    const userId = Number(action.sourceentityvalue) || 0;
    const user = getUsersById ? await getUsersById(userId) : null;

    await changeValues("requestingUser", user, "");
  },

  // Definir prioridade como
  1: async (state, action, { changeValues }) => {
    await changeValues("priorityidbymacro", action.sourceentityid || null, "");
  },
};
export default macroStrategiesRegistration;